import Splide from '@splidejs/splide';

export function initSlider() {
  const photos = document.querySelectorAll('.photo-slider');

  if (photos.length > 0) {
    photos.forEach((photo) => {
      new Splide(photo, {
        mediaQuery: 'min',
        type: 'loop',
        perPage: 1,
        arrows: false,
        classes: {
          pagination: 'splide__pagination photo-slider__pagination',
        },
        breakpoints: {
          '992': {
            destroy: true
          },
        },
      }).mount();
    });
  }

}
